var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-composition"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(_vm.text)?_c('div',{staticClass:"phone_right"},[_c('h4',[_vm._v(_vm._s(_vm.$t("product-page.for-your-information")))]),_c('ul',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }